// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0c54c85b","453":"a2358191","455":"bfe22851","644":"b9744515"}[chunkId] + ".chunk.js";
};